import React from 'react';

const FundingSampleBanner = ({
  variant = 'clients',
  title,
  subtitle,
  primaryActionLabel,
  secondaryActionLabel,
  clearActionLabel,
  onPrimaryAction,
  onSecondaryAction,
  onClear,
  testId = 'funding-sample-banner',
  primaryTestId,
  secondaryTestId,
  clearTestId,
}) => {
  const ghostButton = (label, onClick, actionTestId) => (
    <button
      type="button"
      className="funding-sample-banner__btn funding-sample-banner__btn--ghost"
      data-testid={actionTestId}
      onClick={onClick}
    >
      {label}
    </button>
  );

  const secondaryButton = (label, onClick, actionTestId) => (
    <button
      type="button"
      className="funding-sample-banner__btn funding-sample-banner__btn--secondary"
      data-testid={actionTestId}
      onClick={onClick}
    >
      {label}
    </button>
  );

  const primaryButton = primaryActionLabel ? (
    <button
      type="button"
      className="funding-sample-banner__btn funding-sample-banner__btn--primary"
      data-testid={primaryTestId}
      onClick={onPrimaryAction}
    >
      {primaryActionLabel}
    </button>
  ) : null;

  const actionButtons = variant === 'details'
    ? (
      <>
        {secondaryActionLabel
          ? ghostButton(secondaryActionLabel, onSecondaryAction, secondaryTestId)
          : null}
        {clearActionLabel
          ? secondaryButton(clearActionLabel, onClear, clearTestId)
          : null}
        {primaryButton}
      </>
    )
    : (
      <>
        {clearActionLabel
          ? ghostButton(clearActionLabel, onClear, clearTestId)
          : null}
        {secondaryActionLabel
          ? secondaryButton(secondaryActionLabel, onSecondaryAction, secondaryTestId)
          : null}
        {primaryButton}
      </>
    );

  return (
    <div
      className={`funding-sample-banner funding-sample-banner--${variant}`}
      data-testid={testId}
    >
      <div className="funding-sample-banner__copy">
        <div className="funding-sample-banner__icon" aria-hidden>
          ⚑
        </div>
        <div>
          <div className="funding-sample-banner__title">{title}</div>
          <div className="funding-sample-banner__subtitle">{subtitle}</div>
        </div>
      </div>
      <div className="funding-sample-banner__actions">
        {actionButtons}
      </div>
    </div>
  );
};

export default FundingSampleBanner;
